(() => {
  'use strict';
  let toastTimer;
  let cartQueue = Promise.resolve();

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-product-form]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const add = form.querySelector('[data-add-button]');
      const buy = form.querySelector('[data-buy-now]');
      const quantity = form.querySelector('[name="quantity"]');
      const error = form.querySelector('[data-form-error]');
      const root = form.querySelector('[data-cart-root]').textContent.trim();
      const selected = () => form.querySelector('[name="id"]:checked');
      let busy = false;

      const sync = (changed = false) => {
        const variant = selected();
        if (!variant) return;
        const available = variant.dataset.available === 'true';
        const priced = variant.dataset.priced === 'true';
        add.disabled = buy.disabled = busy || !available || !priced;
        add.textContent = !priced ? add.dataset.pending : !available ? add.dataset.soldOut : add.dataset.label;
        buy.hidden = false;
        quantity.min = variant.dataset.min || '1';
        quantity.step = variant.dataset.step || '1';
        if (variant.dataset.max) quantity.max = variant.dataset.max;
        else quantity.removeAttribute('max');
        if (changed || quantity.type === 'hidden') quantity.value = quantity.min;
        if (changed) {
          error.textContent = '';
          const card = form.closest('.product-card');
          if (card) card.querySelectorAll('a').forEach(link => { link.href = variant.dataset.variantUrl; });
          else if (form.closest('.product-info')) {
            const url = new URL(location.href);
            url.searchParams.set('variant', variant.value);
            history.replaceState({}, '', url);
          }
        }
      };

      form.addEventListener('change', event => {
        if (event.target.name === 'id') sync(true);
      });

      form.addEventListener('submit', event => {
        event.preventDefault();
        if (busy) return;
        const variant = selected();
        if (!variant || variant.dataset.available !== 'true' || variant.dataset.priced !== 'true') return;
        if (!form.reportValidity()) return;
        const qty = Number(quantity.value);
        const min = Number(variant.dataset.min || 1);
        const step = Number(variant.dataset.step || 1);
        const max = variant.dataset.max ? Number(variant.dataset.max) : Infinity;
        if (!Number.isInteger(qty) || qty < min || qty > max || (qty - min) % step !== 0) return;
        if (event.submitter?.hasAttribute('data-buy-now')) {
          location.assign(root + 'cart/' + encodeURIComponent(variant.value) + ':' + qty);
          return;
        }
        const body = new FormData(form);
        error.textContent = '';
        busy = true;
        form.setAttribute('aria-busy', 'true');
        sync();
        cartQueue = cartQueue.catch(() => {}).then(async () => {
          try {
            const response = await fetch(root + 'cart/add.js', {
              method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' }
            });
            const result = await response.json();
            if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : form.querySelector('[data-error-message]').textContent);
            const toast = document.querySelector('[data-cart-toast]');
            if (toast) {
              clearTimeout(toastTimer);
              toast.textContent = form.querySelector('[data-added-message]').textContent;
              toast.classList.add('on');
              toastTimer = setTimeout(() => toast.classList.remove('on'), 3500);
            }
            try {
              const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
              if (cartResponse.ok) {
                const cart = await cartResponse.json();
                document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
              }
            } catch {}
          } catch (failure) {
            error.textContent = failure instanceof TypeError ? form.querySelector('[data-error-message]').textContent : failure.message;
          } finally {
            busy = false;
            form.removeAttribute('aria-busy');
            sync();
          }
        });
      });
      sync();
    });
  };

  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  const header = document.querySelector('.header-section');
  if (header && 'ResizeObserver' in window) {
    new ResizeObserver(() => document.documentElement.style.setProperty('--header', header.offsetHeight + 'px')).observe(header);
  }
})();
